/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientSessionModel } from '../../models/patient-session-model';

export interface StartSession$Params {
  patientID?: number;
  startedDate?: string;
}

export function StartSession(http: HttpClient, rootUrl: string, params?: StartSession$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientSessionModel>> {
  const rb = new RequestBuilder(rootUrl, StartSession.PATH, 'post');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('startedDate', params.startedDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientSessionModel>;
    })
  );
}

StartSession.PATH = '/api/Parent/StartSession';
